import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta(
    "页面不存在 - 朋友的妈妈4影视站",
    "你访问的页面不存在，请返回首页或浏览朋友的妈妈4全部剧集。",
    "朋友的妈妈4,朋友的妈妈4剧集列表",
  );

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <SiteHeader />
      <main className="flex-1 w-full max-w-[1280px] mx-auto px-4 md:px-8 pt-32 md:pt-44 pb-24">
        <div className="mx-auto max-w-xl text-center anim-fade-up">
          <p className="font-heading text-[80px] md:text-[120px] leading-none text-background-200 select-none">
            404
          </p>
          <h1 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
            这个页面走丢了
          </h1>
          <p className="mt-3 text-sm leading-7 text-foreground-500">
            链接可能已经失效，或者地址输入有误。你可以回到首页，或者直接进入剧集列表继续浏览。
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="h-10 px-5 inline-flex items-center rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/episodes"
              className="h-10 px-5 inline-flex items-center rounded-md border border-background-300/60 text-foreground-800 text-sm hover:border-primary-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              查看全部剧集
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}